import { Link } from 'react-router-dom';
import { Check, Users, ShieldCheck, Building2 } from 'lucide-react';
import { PageMeta } from '@/components/PageMeta';

/** For-companies (F80) — condensed from kollez/pages/public/for-companies.html */
export function ForCompaniesPage() {
  return (
    <>
      <PageMeta
        title="For companies"
        description="Hire across every partner campus from one pipeline — post openings, filter, screen with Nexie, interview and offer, all in one place."
        canonical="/for-companies"
      />
      <section className="mx-auto grid max-w-page-wide gap-12 px-5 pb-16 pt-12 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:px-10 lg:pt-20">
        <div className="flex flex-col justify-center">
          <p className="eyebrow">For companies</p>
          <h1 className="display text-ink-primary">Hire across every partner campus, from one pipeline.</h1>
          <p className="mt-6 max-w-[34rem] text-lg leading-8 text-ink-secondary">
            Post an opening once, filter by CGPA and branch, screen with Nexie, interview on-campus or online, and know who accepted in hours — not weeks.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link className="btn btn-primary btn-lg" to="/register/partner">Register as a hiring partner</Link>
            <Link className="btn btn-outline btn-lg" to="/contact?topic=company">Talk to us</Link>
          </div>
        </div>
        <div className="card card-pad grid gap-3">
          <div className="text-sm font-semibold text-ink-tertiary">Sample campus visit</div>
          <div className="flex items-center gap-3 border-b border-line-tertiary pb-3">
            <span className="logo-tile">W</span>
            <div className="flex-1"><div className="font-semibold">Wipro Elite NTH · GIT Rajahmundry</div><div className="text-sm text-ink-tertiary">24 Sept · 7 branches · 1,240 eligible</div></div>
            <span className="tier">Day 1</span>
          </div>
          <dl className="grid grid-cols-2 gap-y-1 text-sm">
            <dt className="text-ink-tertiary">Applications</dt><dd className="text-right">412</dd>
            <dt className="text-ink-tertiary">Shortlisted (auto)</dt><dd className="text-right">64</dd>
            <dt className="text-ink-tertiary">Interviews scheduled</dt><dd className="text-right">40 / 40 slots</dd>
            <dt className="text-ink-tertiary">Offers accepted</dt><dd className="text-right">18 / 21</dd>
          </dl>
        </div>
      </section>

      <section className="border-y border-line-tertiary bg-primary">
        <div className="mx-auto grid max-w-page-wide gap-10 px-5 py-16 lg:grid-cols-3 lg:px-10 lg:py-20">
          {[
            [<Users size={22} key="u" />, 'One pipeline, every campus', 'One CGPA cutoff, one branch list, one panel schedule — served to every partner college that opts in.'],
            [<ShieldCheck size={22} key="s" />, 'No fraud, no fees', 'Kollez verifies every recruiter before students see the opening. Students never pay a fee.'],
            [<Building2 size={22} key="b" />, 'Your ATS, your workflow', 'Export shortlists to your ATS at the click of a button, or run the full offer flow in kollez.'],
          ].map(([icon, title, body], i) => (
            <div key={i}>
              <div className="text-ink-accent">{icon}</div>
              <h3 className="mt-3 font-semibold">{title}</h3>
              <p className="mt-1 text-sm text-ink-secondary">{body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-page-wide px-5 py-16 lg:px-10 lg:py-20">
        <div className="ruled rounded-lg border border-line-tertiary bg-primary px-6 py-12 relative lg:px-16">
          <div className="absolute bottom-0 left-8 top-0 w-[1.5px]" style={{ background: 'rgb(var(--margin) / .8)' }} aria-hidden="true" />
          <h2 className="h-serif max-w-2xl text-3xl lg:text-4xl">Ready to hire from partner campuses?</h2>
          <ul className="mt-6 grid gap-2 text-sm text-ink-secondary max-w-2xl">
            <li className="flex gap-2"><Check size={14} className="mt-0.5 text-ink-success" />Verified partner in 2 working days</li>
            <li className="flex gap-2"><Check size={14} className="mt-0.5 text-ink-success" />First posting free — we walk you through it</li>
            <li className="flex gap-2"><Check size={14} className="mt-0.5 text-ink-success" />No fee to students; kollez removes any listing that charges</li>
          </ul>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link className="btn btn-primary btn-lg" to="/register/partner">Register as a partner</Link>
            <Link className="btn btn-outline btn-lg" to="/pricing">See pricing</Link>
          </div>
        </div>
      </section>
    </>
  );
}
